export default "__VITE_ASSET__DBxwQnt2__"